module.exports = __webpack_public_path__ + "static/media/hiQrCode.015841f3.png";